module.exports = __webpack_public_path__ + "static/header-503d4ad07ecaaf7b6eaa21fbefb846ae.jpg";